// extracted by mini-css-extract-plugin
export default {"title":"Quote_title__M9FPk","edit":"Quote_edit__ahL69","total":"Quote_total__J8MWj"};